import { MobXRepository } from "src/repository/MobXRepository";
import { IPlatform } from "./IPlatform";

export interface IForceUpdateModel {
    platforms: IPlatform[];
    platform: IPlatform | null;
};

class ForceUpdateModel implements IForceUpdateModel {
    private platformsRepository = new MobXRepository<IPlatform[]>([]);
    private platformRepository = new MobXRepository<IPlatform | null>(null);

    get platforms() {
        return this.platformsRepository.data ?? [];
    }

    set platforms(data: IPlatform[]) {
        this.platformsRepository.save(data);
    }

    get platform() {
        return this.platformRepository.data;
    }

    set platform(data: IPlatform | null) {
        this.platformRepository.save(data);
    }

    clear = () => {
        this.platforms = [];
        this.platform = null;
    }
};

export const forceUpdateModel = new ForceUpdateModel();
